module.exports = __webpack_public_path__ + "static/img/ptzs5.fff255b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ptzs5.png
// module id = hGC8
// module chunks = 0